import { createContext } from 'react';

const artistContext = createContext();

export default artistContext;
